export default (theme) => {
    return {
        root: {
            position: 'relative',
            display: 'inline-block',
        },
        selected: {
            cursor: 'auto',
        },
        loading: {
            width: 214,
            height: 160,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: theme.colors.grey[50],
            borderRadius: 8,
            '& span, & svg': {
                width: 42,
                height: 42,
            },
            '& #lottie': {
                marginTop: '-8px !important',
            },
        },
        actions: {
            width: '100%',
            position: 'absolute',
            bottom: -20,
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            '& span': {
                display: 'inline-flex',
                padding: '4px 8px',
                justifyContent: 'center',
                alignItems: 'center',
                border: `1px solid ${theme.colors.grey[50]}`,
                borderRadius: '4px',
                background: theme.colors.primary.white,
                boxShadow:
                    '0px 3px 3px 0px rgba(39, 60, 80, 0.14), 0px 3px 4px 0px rgba(39, 60, 80, 0.12), 0px 1px 8px 0px rgba(39, 60, 80, 0.20)',
                cursor: 'pointer',
            },
        },
        resizers: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            border: `1px solid ${theme.colors.semantic.info500}`,
            boxSizing: 'border-box',
            zIndex: 1,
            '& > div': {
                width: 6,
                height: 6,
                border: `0.7px solid ${theme.colors.semantic.info500}`,
                background: theme.colors.primary.white,
                boxSizing: 'border-box',
                zIndex: 2,
            },
        },
        resizerTopLeft: { position: 'absolute', top: -3, left: -3, cursor: 'nw-resize' },
        resizerTopRight: { position: 'absolute', top: -3, right: -3, cursor: 'ne-resize' },
        resizerBottomLeft: { position: 'absolute', bottom: -3, left: -3, cursor: 'sw-resize' },
        resizerBottomRight: { position: 'absolute', bottom: -3, right: -3, cursor: 'se-resize' },
    };
};
